// extracted by mini-css-extract-plugin
var _1 = "CalendarGridCardTitle-moduleCalendarGridCardTitle__Gv0DF";
export { _1 as "CalendarGridCardTitle" }
